var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTreeFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 4.452v14.266c0 .708-.578 1.282-1.29 1.282H1.29C.578 20 0 19.426 0 18.718V1.282C0 .574.578 0 1.29 0h10.236c.342 0 .67.135.913.376l3.184 3.17c.241.24.377.566.377.906",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.526.5c.21 0 .411.083.56.23h0L15.27 3.9c.147.147.23.345.23.552h0v14.266c0 .216-.088.41-.23.552a.792.792 0 01-.56.23h0H1.29a.792.792 0 01-.56-.23.776.776 0 01-.23-.552h0V1.282c0-.216.088-.41.23-.552A.792.792 0 011.29.5h10.236z",
    stroke: "#EEECEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25.25v2.87c0 .624.482 1.13 1.078 1.13h2.422",
    stroke: "#EEECEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 11.5h6m-6 2h6m-6-4h6m-6-2h3",
    stroke: "#CAC9C8",
    strokeLinecap: "round"
  }))));
}
export default SvgTreeFile;